module.exports = __webpack_public_path__ + "media/public/logoClara-cceaa9e4.svg";